import React from "react";
import { Tag } from "antd";
import {
  ScissorOutlined,
  UserOutlined,
  SmileOutlined,
  CrownOutlined,
  DeleteOutlined,
  HighlightOutlined,
  BgColorsOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";

export type DesignationValue =
  | "STYLIST"
  | "RECEPTIONIST"
  | "THERAPIST"
  | "MANAGER"
  | "CLEANER"
  | "MAKEUP_ARTIST"
  | "NAIL_TECHNICIAN"
  | "OTHER";

interface DesignationTagProps {
  value: DesignationValue;
}

const designationMap: Record<
  DesignationValue,
  { label: string; icon: React.ReactNode; color: string }
> = {
  STYLIST: { label: "Stylist", icon: <ScissorOutlined />, color: "purple" },
  RECEPTIONIST: {
    label: "Receptionist",
    icon: <UserOutlined />,
    color: "volcano",
  },
  THERAPIST: { label: "Therapist", icon: <SmileOutlined />, color: "green" },
  MANAGER: { label: "Manager", icon: <CrownOutlined />, color: "gold" },
  CLEANER: { label: "Cleaner", icon: <DeleteOutlined />, color: "red" },
  MAKEUP_ARTIST: {
    label: "Makeup Artist",
    icon: <HighlightOutlined />,
    color: "magenta",
  },
  NAIL_TECHNICIAN: {
    label: "Nail Technician",
    icon: <BgColorsOutlined />,
    color: "geekblue",
  },
  OTHER: { label: "Other", icon: <EllipsisOutlined />, color: "gray" },
};

const DesignationTag: React.FC<DesignationTagProps> = ({ value }) => {
  const designation = designationMap[value];

  if (!designation) return null;

  return (
    <Tag icon={designation.icon} color={designation.color}>
      {designation.label}
    </Tag>
  );
};

export default DesignationTag;
